import React, { useState } from 'react';
import { X, History, HelpCircle, BookOpen } from 'lucide-react';

const HamburgerMenu = ({ isOpen, onClose, onMenuItemClick }) => {
  const menuItems = [
    {
      id: 'history',
      label: 'Mon historique de mise',
      icon: History,
      action: () => onMenuItemClick('history')
    },
    {
      id: 'how-to-play',
      label: 'Comment jouer?',
      icon: HelpCircle,
      action: () => onMenuItemClick('how-to-play')
    },
    {
      id: 'rules',
      label: 'Règle de Jouer',
      icon: BookOpen,
      action: () => onMenuItemClick('rules')
    }
  ];

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop - Click outside to close */}
      <div
        className="fixed inset-0 z-40"
        onClick={onClose}
      />

      {/* Menu Panel - Card Style */}
      <div className="absolute top-12 right-0 w-56 bg-white rounded-lg shadow-xl z-50 border border-gray-200 animate-in slide-in-from-top-2 duration-200">
        <div className="py-2">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent click from bubbling to backdrop
                  item.action();
                  onClose();
                }}
                className={`w-full flex items-center px-4 py-3 text-left hover:bg-gray-50 transition-colors text-sm ${
                  index !== menuItems.length - 1 ? 'border-b border-gray-100' : ''
                }`}
              >
                <Icon className="w-4 h-4 text-gray-600 mr-3" />
                <span className="text-gray-900 font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default HamburgerMenu;
// comentaire